import { Repeat } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

// Name describes the role (swap the two video views), not the drawing. The
// drawing is the conventional cycle — two rounded arrows following each other —
// which reads as "exchange" where `RefreshCw` would read as "reload the page".
export function SwapIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Repeat
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
